import React, { useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FeedbackFilter from "./FeedbackFilter";
import _, { set } from "lodash";
import {
  Box,
  Button,
  Divider,
  Typography,
  Badge,
  Drawer,
  IconButton,
  Tooltip,
  Stack,
  // Grid,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Styles from "./CommonMail.module.scss";
import MailIcon from "@mui/icons-material/Mail";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CloseIcon from "@mui/icons-material/Close";
// import { getUser } from "../../services/user.service";
import moment from "moment";
// import { ColorRing } from "react-loader-spinner";
// import { errorMessage } from "../../utils/errorHandleFunctions";
import ModeIcon from "@mui/icons-material/Mode";
import DeleteIcon from "@mui/icons-material/Delete";
import InterpreterModeIcon from "@mui/icons-material/InterpreterMode";
import QrCode2Icon from "@mui/icons-material/QrCode2";
// import ConfirmBox from "../../sharedComponents/ConfirmBox/ConfirmBox";
// import { deleteServiceRequest } from "../../services/serviceRequest.service";
// import { toastError } from "../../utils/toaster";
// import { Roles } from "../../constants/menus";
// import { Timer } from "../../constants/timer";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { getSpecificUser, getUser } from "../../services/user.service";
import { getRole } from "../../services/category.service";
import {
  EMAIL_STATUS,
  ROLES,
  SEND_STATUS_OPTIONS,
} from "../../constant/constant";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterIcon from "../../assets/images/mynaui_filter.png"
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { ColorRing } from "react-loader-spinner";
import Timer from "../../utils/Timer";
import { callMailFunctApi } from "../../services/ticket.service";
import RatingComp from "./Rating";

const FeedbackReceive = ({
  data,
  setData,
  setSelectedData,
  locationData,
  onSearchChange,
  // selectedStatus,
  setSelectedStatus,
  setSelectedTimerStatus,
  setSelectedSendStatus,
  setSelectedTab,
  setUserId,
  setDepartmentId,
  setOpenAddForm,
  openLoader,
  setSelectedFormData,
  setFormTpe,
  getData,
  selectedDate,
  setSelectedDate,
  filterKey,
  setFilterKey,
  publicHolidays = [],
  selectedStatus,
  setSupportTicket,
  supportTicket,
}) => {
  const { RangePicker } = DatePicker;
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [userData, setUserData] = useState([]);
  const [openConfirmBox, setOpenConfirmBox] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [definedRole, setDefinedRole] = useState(null);
  const [viewConfig, setViewConfig] = useState({
    isEdit: false,
    isDelete: false,
  });

  // console.log("datadata", data);

  const [statusValue, setStatusValue] = useState("Open");
  const [timerValue, setTimerValue] = useState(null);
  const [sendStatusValue, setSendStatusValue] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  // "near_finish" | "finished"
  const [sortMode, setSortMode] = useState("near_finish");
  // const [userData, setUserData] = useState([]);
  const [selectedTabValue, setSelectedTabValue] = useState("Unread");
  const [userValue, setUserValue] = useState({
    userId: localStorage.getItem("userId"),
    userName: localStorage.getItem("name"),
    role: localStorage.getItem("role"),
  });
  let StatusOptions = [...SEND_STATUS_OPTIONS];
  // const colorScheme = {
  //   2: ["#FFEB3B", "#000000"],
  //   // 2: ["#00FF7F ", "#FFFFFF"],
  //   3: ["#00ff359c ", "#000000"],
  //   4: ["#ff00009c", "#000000"],
  //   10: ["#f0ff009c", "#000000"],
  // };

  React.useEffect(() => {
    const storedRole = localStorage.getItem("role");
    if (storedRole) {
      setDefinedRole(storedRole);
    }
  }, []);
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    setSelectedTabValue(tab);
  };

  const DeleteFunction = () => {
    // deleteServiceRequest(selectedId).then((res) => {
    //   setOpenConfirmBox(false);
    //   toastError(res.message);
    //   getData();
    //   setSelectedData({});
    // });
  };
  const filterFunction = () => {
    // userId / departmentId are already set directly by the Department,
    // Assignee and User dropdowns' onChange handlers. Re-deriving them from
    // `values` here wiped the admin "User" selection (which never writes to
    // `values.assignedTo`), so just close the drawer and trigger the refetch.
    setOpenFilterDrawer(false);
    setFilterKey(!filterKey);
  };

  React.useEffect(() => {
    let tickets = data?.map(e => e?.dataInfo)?.flat() || [];
    setTotalCount(tickets?.length || 0)
  }, [data])
  // React.useEffect(() => {
  //   setDifinedRole(localStorage.getItem("role"));
  //   if (definedRole === Roles[0]) {
  //     setViewConfig({
  //       isEdit: true,
  //       isView: true,
  //       isDelete: true,
  //       isAction: true,
  //     });
  //   } else if (definedRole === Roles[1]) {
  //     setViewConfig({
  //       isEdit: true,
  //       isView: true,
  //       isDelete: false,
  //       isAction: true,
  //     });
  //   } else if (definedRole === Roles[2]) {
  //     setViewConfig({
  //       isEdit: true,
  //       isView: true,
  //       isDelete: false,
  //       isAction: true,
  //     });
  //   } else {
  //     setViewConfig({
  //       isEdit: false,
  //       isView: false,
  //       isDelete: false,
  //       isAction: false,
  //     });
  //   }
  // }, [definedRole]);

  const SearchOption = [
    { label: "All", value: null },
    { label: "Open", value: "Open" },
    { label: "Closed", value: "Closed" },
  ];
  const TimerStatusOption = [
    { label: "All", value: null },
    { label: "In Progress", value: 1 },
    { label: "Completed", value: 2 },
  ];
  const TimerFilterOption = [
    { label: "All", value: null },
    { label: "With In Time", value: 1 },
    { label: "Out Of Time", value: 2 },
  ];
  const TimerOption = [
    { label: "All", value: null },
    { label: "With In Time", value: false },
    { label: "Out Of Time", value: true },
  ];
  const TimerSendStatusOption = [
    // "All" must be null: the filter drawer maps null -> no filter, and the
    // old value of 1 was sent to the API as a bogus sendStatus.
    { label: "All", value: null },
    { label: "Initial", value: 2 },
    { label: "Need info", value: 5 },
    { label: "Response", value: 6 },
    { label: "Final", value: 4 },
  ];
  const SendStatusOption = [
    { label: "All", value: null },
    { label: "Initial", value: 2 },
    // { label: "Follow up", value: 3 },
    { label: "Need info", value: 5 },
    { label: "Final", value: 4 },
  ];

  const callFunct = async () => {
    await callMailFunctApi();
  };
  React.useEffect(() => {
    setSelectedStatus("Open");
    callFunct();
  }, []);

  // useEffect(() => {
  //   getSpecificUser().then((res) => {
  //     const modifiedData = res?.data?.data?.map((el) => ({
  //       ...el,
  //       label: el?.name,
  //     }));
  //     const addOne = { label: "All", _id: null };
  //     setUserData([addOne, ...modifiedData]);
  //   });
  // }, []);

  useEffect(() => {
    // Use getUser (all active users) — getSpecificUser requires role/project
    // linkage that may not be set up, causing empty results.
    getUser().then((res) => {
      const list = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : [];

      const modifiedData = list.map((el) => ({
        ...el,
        label: el?.name || el?.userName || "Unknown",
      }));

      const addOne = { label: "All", _id: null };
      setUserData([addOne, ...modifiedData]);
    }).catch(() => {});
  }, []);


  const [selectedItemId, setSelectedItemId] = useState(null);

  const currentRole = localStorage.getItem("role");
  const [department, setDepartment] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [values, setValues] = useState({
    assignedDepartmentId: "",
    assignedTo: "",
  });

  const findDeptByUserId = (roleShortName) => {
    if (!roleShortName || roleShortName === "All") return userData;

    let normalised = roleShortName;
    if (normalised === "FEEDBACK-ADMIN" || normalised === "Management") normalised = "Admin";
    if (normalised === "PROJECT MANAGER") normalised = "PM";

    const filtered = userData.filter(
      (user) =>
        user?.roleData?.shortName === normalised ||
        user?.roleData?.name === roleShortName ||
        user?.role === roleShortName
    );

    // If no match found (roleData not populated), return all users as fallback
    if (filtered.length === 0) return userData;

    return filtered.map((ele) => ({ ...ele, label: ele?.label || ele?.name || "" }));
  };

  const GetCategoryDatas = async () => {
    try {
      const res = await getRole();
      const modifiedData =
        res?.data
          .filter(
            (e) =>
              e.name === "HR" ||
              e.name === "PROJECT MANAGER" ||
              e.name === "FEEDBACK-ADMIN" ||
              e.name === "IT SUPPORT"
          )
          .map((e) => ({
            ...e,
            label: e.shortName,
            id: e._id,
          })) || [];
      const addOne = { label: "All", id: null };
      setDepartment([addOne, ...modifiedData]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetCategoryDatas();
  }, []);

  const setFieldValue = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (locationData && Object.keys(locationData).length > 0) {
      setSelectedData(locationData);
      setSelectedTab("All");
      setSelectedTabValue("All");
    }
  }, [locationData, setSelectedData, setSelectedTab, setSelectedTabValue]);

  useEffect(() => {
    if (
      !locationData ||
      !Array.isArray(data) ||
      data.length === 0 ||
      selectedItemId
    ) {
      return;
    }

    const matchedTicket = data
      .flatMap((ticketGroup) => ticketGroup?.dataInfo || [])
      .find((ticket) => ticket?._id === locationData?._id);

    if (matchedTicket) {
      setSelectedData(matchedTicket);
      setSelectedItemId(matchedTicket._id);
    }
  }, [data, locationData, selectedItemId, setSelectedData]);

  const now = Date.now();

  // Remaining ms: negative = overdue (red), positive = still running (green)
  const getRemaining = (ticket) => {
    const endMs = ticket.tempEndTime
      ? new Date(ticket.tempEndTime).getTime()
      : new Date(ticket.createdAt).getTime() + 9 * 60 * 60 * 1000;
    return endMs - now;
  };

  const isFinished = (ticket) => ticket.ticketStatus !== "0";

  const sortTickets = (list) => {
    const arr = [...list];
    if (sortMode === "near_finish") {
      // Overdue (red, most negative) first → near-expiry (green, small positive) next → closed last
      return arr.sort((a, b) => {
        const aF = isFinished(a), bF = isFinished(b);
        if (aF !== bF) return aF ? 1 : -1;
        return getRemaining(a) - getRemaining(b);
      });
    }
    // "finished" — closed tickets first, then open by remaining time
    return arr.sort((a, b) => {
      const aF = isFinished(a), bF = isFinished(b);
      if (aF !== bF) return aF ? -1 : 1;
      return getRemaining(a) - getRemaining(b);
    });
  };

  const loggedInUserId = userValue.userId;
  const isMyGroup = (group) =>
    String(group?.assignedToInfo?._id) === String(loggedInUserId);

  const sortedData = [...(data || [])]
    .map((group) => ({ ...group, dataInfo: sortTickets(group.dataInfo || []) }))
    .sort((ga, gb) => {
      // Logged-in user's own assigned group always comes first, ahead of
      // every other assignee's group.
      const aMine = isMyGroup(ga);
      const bMine = isMyGroup(gb);
      if (aMine !== bMine) return aMine ? -1 : 1;

      if (sortMode === "near_finish") {
        const aMin = Math.min(...(ga.dataInfo.filter((t) => !isFinished(t)).map(getRemaining).concat(Infinity)));
        const bMin = Math.min(...(gb.dataInfo.filter((t) => !isFinished(t)).map(getRemaining).concat(Infinity)));
        return aMin - bMin;
      }
      return 0;
    });

  const handleRead = async (id) => {
    const updatedData = data.map((e) =>
      e._id === id ? { ...e, isRead: true } : e
    );
    setData(updatedData);
    await callMailFunctApi();
  };
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden", backgroundColor: "#fff" }}>
      {/* Header Section */}
      <Box sx={{ padding: "16px 20px 0" }}>
        {/* Search Bar */}
        <Box sx={{
          display: "flex", alignItems: "center",
          border: "1px solid #E6E6E6", borderRadius: "6px",
          padding: "8px 14px", marginBottom: "12px",
          width: "100%", backgroundColor: "#F9FAFB",
          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)"
        }}>
          <SearchOutlinedIcon sx={{ color: "#667085", fontSize: "20px", mr: 1 }} />
          <input
            className="SearchInputBox"
            placeholder="Search here..."
            onChange={onSearchChange}
            style={{
              border: "none", outline: "none", width: "100%",
              fontSize: "14px", fontFamily: "Open Sans, sans-serif",
              backgroundColor: "transparent", color: "#667085"
            }}
          />
        </Box>

        {/* Count & Tabs */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#212121", fontFamily: "Open Sans, sans-serif" }}>
              Total Count: {totalCount.toString().padStart(2, '0')}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Tooltip title={sortMode === "near_finish" ? "Switch to: Finished first" : "Switch to: Near finish first"}>
                <Box
                  onClick={() => setSortMode((v) => v === "near_finish" ? "finished" : "near_finish")}
                  sx={{
                    display: "flex", alignItems: "center", gap: "5px",
                    cursor: "pointer", userSelect: "none",
                    px: "9px", py: "4px", borderRadius: "20px",
                    border: "1.5px solid #00675D",
                    bgcolor: "#E8F5E9",
                    transition: "all 0.15s",
                    "&:hover": { bgcolor: "#C8E6C9" },
                  }}
                >
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#00675D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="9" y2="18"/>
                  </svg>
                  <Typography sx={{ fontSize: "10.5px", fontWeight: 700, color: "#00675D", fontFamily: "Open Sans, sans-serif", lineHeight: 1, whiteSpace: "nowrap" }}>
                    {sortMode === "near_finish" ? "Near finish" : "Finished first"}
                  </Typography>
                </Box>
              </Tooltip>
              <img src={FilterIcon} alt="FilterIcon" style={{ cursor: "pointer", height: "24px", width: "24px" }} onClick={() => setOpenFilterDrawer(true)} />
            </Stack>
          </Box>

          <Box sx={{ borderBottom: "1px solid #EEEEEE", width: "100%" }}>
            <Tabs
              value={selectedTabValue}
              onChange={(e, v) => handleTabChange(v)}
              sx={{
                minHeight: "36px",
                "& .MuiTabs-indicator": { backgroundColor: "#00675D", height: "3px" },
                "& .MuiTab-root": {
                  textTransform: "none",
                  minHeight: "36px",
                  padding: "6px 0",
                  marginRight: "20px",
                  fontSize: "14px",
                  fontWeight: "600",
                  fontFamily: "Open Sans, sans-serif",
                  color: "#9E9E9E",
                  "&.Mui-selected": { color: "#00675D" }
                }
              }}
            >
              <Tab label="Unread" value="Unread" />
              <Tab label="All" value="All" />
            </Tabs>
          </Box>
        </Box>
      </Box>

      {/* List Section */}
      <Box className={Styles.scrollBox} sx={{ padding: "16px 0px", height: "calc(100vh - 180px)", overflowY: "auto", display: "flex", flexDirection: "column" }}>
        {openLoader ? (
          <div style={{ textAlign: "center", width: "100%", marginTop: "20px" }}>
            <ColorRing visible={true} height="60" width="60" ariaLabel="color-ring-loading" colors={["#00675D", "#00675D", "#00675D", "#00675D", "#00675D"]} />
          </div>
        ) : (
          <>
            {sortedData?.length > 0 ? (
              sortedData.map(({ assignedToInfo, dataInfo }, groupIndex) => (
                <div key={groupIndex}>
                  {/* Group Header */}
                  <Box sx={{
                    backgroundColor: "#EEEEEE",
                    padding: "7px 16px",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                  }}>
                    <Typography sx={{ fontWeight: "700", fontSize: "12px", textTransform: "uppercase", color: "#000", fontFamily: "Open Sans, sans-serif" }}>
                      {assignedToInfo?.name || "Unassigned"}
                    </Typography>
                    {sortMode === "near_finish" && groupIndex === 0 && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: "4px", px: "7px", py: "2px", borderRadius: "20px", bgcolor: "#FFEBEE", border: "1px solid #FFCDD2" }}>
                        <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "#E53935", animation: "pulse 1.5s ease-in-out infinite", "@keyframes pulse": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0.3 } } }} />
                        <Typography sx={{ fontSize: "10px", fontWeight: 800, color: "#E53935", fontFamily: "Open Sans, sans-serif" }}>URGENT</Typography>
                      </Box>
                    )}
                    {sortMode === "near_finish" && groupIndex > 0 && (
                      <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#9E9E9E", fontFamily: "Open Sans, sans-serif" }}>
                        #{groupIndex + 1} in queue
                      </Typography>
                    )}
                  </Box>
                  {dataInfo.map((e, i) => {
                    let TIME = e?.createdAt;
                    let EXTRA_TIMER = null;
                    let END_TIME = null;
                    let EXPIRY = Number(e?.expiry) || 2;
                    let DURATION = 9;
                    let HR = null,
                      MIN = null,
                      SEC = null,
                      DURATION_ = 24;

                    const filteredMsg = e?.replyMessages?.filter(
                      (msg) => !msg?.isAutoGenerated
                    );
                    let indx;
                    const recentReplyData =
                      filteredMsg?.[filteredMsg?.length - 1];

                    for (indx = filteredMsg?.length - 2; indx >= 0;) {
                      if (
                        ["2", "3", "4", "5"].includes(
                          filteredMsg[indx]?.sendStatus
                        )
                      ) {
                        break;
                      }
                      indx--;
                    }

                    const recentReplyBeforeData = filteredMsg?.[indx];
                    if (
                      !recentReplyData?.sendStatus &&
                      recentReplyBeforeData?.sendStatus == "5"
                    ) {
                      EXTRA_TIMER = recentReplyData?.date;
                      DURATION_ = 24;
                      StatusOptions = StatusOptions.map((opt) =>
                        opt?.value == "5" ? { ...opt, label: "Response" } : opt
                      );
                    } else if (recentReplyData?.sendStatus == "5") {
                      EXTRA_TIMER = recentReplyData?.date;
                      DURATION_ = 24;
                    } else if (
                      !recentReplyData?.sendStatus &&
                      recentReplyBeforeData?.sendStatus == "4"
                    ) {
                      EXTRA_TIMER = recentReplyData?.date;
                      DURATION_ = 9;
                      HR = 18;
                      MIN = 0;
                      SEC = 0;
                      StatusOptions = StatusOptions.map((opt) =>
                        opt?.value == "4" ? { ...opt, label: "Response" } : opt
                      );
                    } else if (recentReplyData?.sendStatus == "4") {
                      EXTRA_TIMER = recentReplyData?.date;
                      DURATION_ = 9;
                      HR = 18;
                      MIN = 0;
                      SEC = 0;
                    }

                    if (e?.tempEndTime) {
                      const givenDay = moment
                        .utc(e?.tempEndTime)
                        .startOf("day");
                      const today = moment.utc().startOf("day");
                      const hourTest = moment.utc(e?.tempEndTime).hour();
                      if (givenDay.isSame(today) && hourTest < 18) {
                        END_TIME = e?.tempEndTime;
                      }
                    }

                    const dateStr = END_TIME ? moment(END_TIME) : null;
                    let hours = null;
                    let minutes = null;
                    let seconds = null;
                    if (dateStr) {
                      hours = dateStr.hour() > 18 ? 18 : dateStr.hour();
                      minutes = dateStr.minute();
                      seconds = dateStr.second();
                    }

                    const isSelected = selectedItemId === e._id;

                    return (
                      <Box
                        key={i}
                        onClick={() => {
                          setSelectedData(e);
                          handleRead(e._id);
                          setSelectedItemId(e._id);
                        }}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "stretch",
                          backgroundColor: isSelected ? "#E0F2F1" : "#fff",
                          border: "1.2px solid #E6E6E6",
                          padding: "8px",
                          marginBottom: "0px",
                          cursor: "pointer",
                          borderLeft: isSelected ? "4px solid #00675D" : "4px solid transparent",
                          "&:hover": { backgroundColor: "#D1ECE933" }
                        }}
                      >
                        {/* Upper Section: Avatar and Main Info Section */}
                        <Box sx={{ display: "flex", gap: "12px", width: "100%", alignItems: "center" }}>
                          {/* Left: Avatar */}
                          <Tooltip title={e?.createdByInfo?.name || e?.name || "Unknown"}>
                            <Box sx={{
                              width: "36px", height: "36px", borderRadius: "50%",
                              backgroundColor: "#26A69A", color: "#fff",
                              display: "flex", justifyContent: "center", alignItems: "center",
                              fontWeight: 600, fontSize: "14px", flexShrink: 0,
                              fontFamily: "Open Sans, sans-serif",
                              mt: 0.5
                            }}>
                              {e?.createdByInfo?.name ? e.createdByInfo.name.substring(0, 2).toUpperCase() : (e?.name ? e.name.substring(0, 2).toUpperCase() : "NA")}
                            </Box>
                          </Tooltip>

                          {/* Middle: Info */}
                          <Box sx={{ display: "flex", flexDirection: "column", flex: 1, gap: "4px", minWidth: 0 }}>
                            {/* Row 1: ID - Name (Left) and Icons (Right) */}
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Typography sx={{
                                fontSize: "14px", fontWeight: "600", color: "#212121",
                                fontFamily: "Open Sans, sans-serif", display: "flex",
                                alignItems: "center", gap: "5px", whiteSpace: "nowrap",
                                overflow: "hidden", textOverflow: "ellipsis"
                              }}>
                                <span style={{ color: "#00675D" }}>{e.ticketId}</span> -
                                <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {e.createdByInfo?.name || e?.name || "Unknown"}
                                </span>
                              </Typography>

                              <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                                {e.SupportTicket && <SupportAgentIcon sx={{ color: "#26A69A", fontSize: 20 }} />}
                                <Box sx={{ display: "flex", alignItems: "center", color: "#26A69A" }}>
                                  {e?.mode === "0" ? <InterpreterModeIcon sx={{ fontSize: 20 }} /> :
                                    e?.mode === "1" ? <MailIcon sx={{ fontSize: 20 }} /> :
                                      <QrCode2Icon sx={{ fontSize: 20 }} />}
                                </Box>
                                <DeleteIcon
                                  sx={{
                                    fontSize: "20px",
                                    color: "#BDBDBD",
                                    cursor: "pointer",
                                    display: viewConfig.isDelete ? "block" : "none",
                                    "&:hover": { color: "#D32F2F" }
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setSelectedId(e._id);
                                    setOpenConfirmBox(true);
                                  }}
                                />
                              </Box>
                            </Box>

                            {/* Row 2: Assigned To */}
                            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#000000", fontFamily: "Open Sans, sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              Assigned To: {e?.assignedToInfo?.name || "Unassigned"}
                            </Typography>

                            {/* Row 3: Message */}
                            <Typography sx={{ fontSize: "12px", color: "#475467", fontWeight: 600, fontFamily: "Open Sans, sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {e.lastMessage ? (
                                /^\s*<[^>]+>/i.test(e.lastMessage) ? "Formatted Content" : e.lastMessage
                              ) : "No message"}
                            </Typography>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Typography sx={{
                                fontSize: "14px", color: "#00675D", fontWeight: 600,
                                fontFamily: "Open Sans, sans-serif", whiteSpace: "nowrap",
                                overflow: "hidden", textOverflow: "ellipsis"
                              }}>
                                OD: {moment(e.createdAt).format("DD MMM YYYY, hh:mm A")}
                              </Typography>
                              {e?.unReadCount > 0 && (
                                <Box sx={{
                                  width: "20px", height: "20px", borderRadius: "50%",
                                  backgroundColor: "#004D40", color: "#fff",
                                  display: "flex", justifyContent: "center", alignItems: "center",
                                  fontSize: "10px", fontWeight: "bold",
                                }}>
                                  {e.unReadCount}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </Box>

                        {/* Lower Section: Date, Unread Count, Timers and Badges (Full Width) */}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", pt: 1, pl: "48px" }}>

                          {/* Row 5: Timers and Badges (Horizontal) */}
                          <Box sx={{ display: "flex", alignItems: "center", gap: "3px", justifyContent: "flex-start", flexWrap: "wrap" }}>
                            <span style={{
                              backgroundColor: e.ticketStatus === "0" ? "#FFD6D6" : "#FFD6D6",
                              color: e.ticketStatus === "0" ? "#DB3A3A" : "#DB3A3A",
                              padding: "2px 8px", borderRadius: "12px", fontSize: "11px", fontWeight: "700", fontFamily: "Open Sans, sans-serif", minWidth: "40px", textAlign: "center", display: "inline-block"
                            }}>
                              {e.ticketStatus === "0" ? "Open" : "Closed"}
                            </span>

                            <Timer
                              startDate={TIME}
                              endHours={EXPIRY}
                              holidays={publicHolidays}
                              ticketStatus={e?.ticketStatus}
                              endTime={e?.tempEndTime || null}
                              WORK_END_HOUR={hours || 18}
                              minutes={minutes || 0}
                              seconds={seconds || 0}
                              DURATION={DURATION}
                            />

                            {e.sendStatus && (
                              <span style={{
                                backgroundColor: "#81F0E5", color: "#00675D",
                                padding: "2px 8px", borderRadius: "12px", fontSize: "11px", fontWeight: "700", fontFamily: "Open Sans, sans-serif", minWidth: "40px", textAlign: "center", display: "inline-block"
                              }}>
                                {StatusOptions.find(o => o.value == e.sendStatus)?.label || "Status"}
                              </span>
                            )}

                            {EXTRA_TIMER && (
                              <Timer
                                startDate={EXTRA_TIMER}
                                endHours={1}
                                holidays={publicHolidays}
                                ticketStatus={e?.ticketStatus}
                                WORK_END_HOUR={HR}
                                minutes={MIN}
                                seconds={SEC}
                                DURATION={DURATION_}
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>
                    );
                  })}
                </div>
              ))
            ) : (
              <Typography style={{ textAlign: "center", marginTop: "20px", color: "#9E9E9E", fontSize: "14px" }}>
                No Feedback Found
              </Typography>
            )}
          </>
        )}
      </Box>

      <Drawer
        anchor="right"
        open={openFilterDrawer}
        onClose={() => setOpenFilterDrawer(false)}
        PaperProps={{
          sx: { width: 350, p: 2 }
        }}
      >
        <FeedbackFilter
          open={openFilterDrawer}
          handleClose={() => setOpenFilterDrawer(false)}
          currentRole={currentRole}
          // State
          userId={userValue.userId} setUserId={setUserId}
          userValue={userValue} setUserValue={setUserValue}
          departmentId={values.assignedDepartmentId} setDepartmentId={setDepartmentId}
          roleName={roleName} setRoleName={setRoleName}
          values={values} setValues={setValues}
          statusValue={statusValue} setStatusValue={setStatusValue}
          timerValue={timerValue} setTimerValue={setTimerValue}
          sendStatusValue={sendStatusValue} setSendStatusValue={setSendStatusValue}
          selectedDate={selectedDate} setSelectedDate={setSelectedDate}
          // Options
          userData={userData}
          department={department}
          findDeptByUserId={findDeptByUserId}
          SearchOption={SearchOption}
          TimerFilterOption={TimerFilterOption}
          TimerSendStatusOption={TimerSendStatusOption}

          // Handlers
          filterFunction={filterFunction}
          setFieldValue={setFieldValue}
          setSelectedStatus={setSelectedStatus}
          setSelectedTimerStatus={setSelectedTimerStatus}
          setSelectedSendStatus={setSelectedSendStatus}

          // Follow Up Logic
          supportTicket={supportTicket}
          setSupportTicket={setSupportTicket}
          filterKey={filterKey}
          setFilterKey={setFilterKey}
        />
      </Drawer>
      {/* <ConfirmBox
        open={openConfirmBox}
        title="Delete"
        content="Are you sure want to Delete this record ?"
        confirmButton="Delete"
        setOpenConfirmBox={setOpenConfirmBox}
        confirmFunction={DeleteFunction}
      /> */}
    </div >
  );
};

export default FeedbackReceive;
